import { Api } from "@api";
import { State } from "../";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { UserSettings, UserSettingsAction } from "../types/user_settings";

function getUserSettingsRequest(): UserSettingsAction {
  return {
    type: ActionType.GET_USER_SETTINGS_REQUEST,
  };
}

function getUserSettingsSuccess(settings: UserSettings): UserSettingsAction {
  return {
    type: ActionType.GET_USER_SETTINGS_SUCCESS,
    settings,
  };
}

function getUserSettingsFailure(error: Error): UserSettingsAction {
  return {
    type: ActionType.GET_USER_SETTINGS_FAILURE,
    error,
  };
}

export function getUserSettings(): ThunkAction<
  void,
  State,
  unknown,
  UserSettingsAction
> {
  return async (dispatch, getState) => {
    const { network } = getState();

    if (!network.fetching.user_settings) {
      dispatch(getUserSettingsRequest());
      try {
        const settings = await Api.user.settings.getSettings();

        dispatch(getUserSettingsSuccess(settings));
      } catch (error) {
        dispatch(getUserSettingsFailure(error));
      }
    }
  };
}

function updateUserSettingsRequest(): UserSettingsAction {
  return {
    type: ActionType.UPDATE_USER_SETTINGS_REQUEST,
  };
}

function updateUserSettingsSuccess(settings: UserSettings): UserSettingsAction {
  return {
    type: ActionType.UPDATE_USER_SETTINGS_SUCCESS,
    settings,
  };
}

function updateUserSettingsFailure(error: Error): UserSettingsAction {
  return {
    type: ActionType.UPDATE_USER_SETTINGS_FAILURE,
    error,
  };
}

export function updateUserSettings(
  payload: UserSettings
): ThunkAction<Promise<any>, State, unknown, UserSettingsAction> {
  return async (dispatch) => {
    if (payload) {
      dispatch(updateUserSettingsRequest());
      try {
        const settings = await Api.user.settings.putSettings(payload);

        return dispatch(updateUserSettingsSuccess(settings));
      } catch (error) {
        return dispatch(updateUserSettingsFailure(error));
      }
    }
  };
}
